export const enterPhone = 'ENTER_PHONE';
export const verifyPhone = 'VERIFY_PHONE';
export const transitionScreen = 'TRANSITION_SCREEN';
